import { FC } from 'react';
import Typography from '@mui/material/Typography';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { numberToCurrencyString } from 'further-ui/utils';
import { Row } from 'further-ui/components/Layout';
import AccountingFooter from '../components/AccountingFooter';

type GeneralLedgerTotalProps = {
  total: number;
  baseCurrency: CurrencyCode;
};

const GeneralLedgerTotal: FC<GeneralLedgerTotalProps> = ({
  total,
  baseCurrency,
}) => {
  const totalFormatted = numberToCurrencyString(total, {
    currency: baseCurrency,
    negativeInBrackets: true,
  });
  const showZeroTick = total === 0;

  return (
    <AccountingFooter>
      <Row justify="space-between" alignItems="center" spacing="sm">
        <Typography variant="h6" color="grey.600" lineHeight={1}>
          General ledger total
        </Typography>
        <Row alignItems="center" centered spacing="xs">
          <Typography variant="h6" lineHeight={1}>
            {totalFormatted}
          </Typography>
          {showZeroTick ? <CheckCircle color="success" /> : null}
        </Row>
      </Row>
    </AccountingFooter>
  );
};

export default GeneralLedgerTotal;
